import React, { memo, useEffect } from "react";
import { isNil } from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import Layout from "../../Layout";
import { ApplicationState } from "../../../store";
import { Data } from "../../../store/possoftware/types";
import { getById } from "../../../store/possoftware/queries";
import { fetchRequest as fetchPosSoftware } from "../../../store/possoftware/actions";
import Alert from "@mui/lab/Alert";
import PosSoftwareEditForm from "../posSoftwareEditForm/PosSoftwareEditForm";
import useSession from "../../../effects/useSession";
import pageStyles from "../../pageStyles";
import PageHeading from "../../../common/pageHeading/PageHeading";

const CREATE = "CREATE";
const UPDATE = "UPDATE";

interface SaveErrorProps {
  children: React.ReactNode;
}

const SaveError: React.FC<SaveErrorProps> = (props) => (
  <Alert severity="error">{props.children}</Alert>
);

function PosSoftwareEdit() {
  const dispatch = useDispatch();
  const session = useSession();
  const classes = pageStyles();
  const { id } = useParams<{ id: string }>();

  const mode = id ? UPDATE : CREATE;

  const posSoftwareState = useSelector(
    (state: ApplicationState) => state.posSoftware
  );

  useEffect(() => {
    !isNil(id) && dispatch(fetchPosSoftware(id));
  }, []);

  const posSoftware = useSelector(id ? getById(id) : () => null) as Data;

  const headingText = () => {
    return mode === CREATE ? "New POS Software" : "Edit POS Software";
  };
  const isCreate = Boolean(mode === CREATE);

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading={headingText()} />
              </Paper>
            </Grid>
            <Grid xs={12}>
              <Paper className={classes.paper}>
                <PosSoftwareEditForm isCreate={isCreate} posSoftware={posSoftware} />
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}

export default memo(PosSoftwareEdit);
